export const API_URL = {

    // kuvah Api start 

    SentOtp: 'auth/send_otp',
    verify_otp: 'auth/verify_otp',
    register: 'auth/register',
    banners: 'banners',
    categories: 'categories',
    products: 'products/latest',
    ReviewsList: 'products/reviews',
    productBySlug: 'products/details',
    saveReviews: 'products/reviews/submit',
    reviewsByProductId: 'products/reviews',
    categoriesbyId: 'categories/products',
    blogs: 'blogs',
    customerInfo: 'customer/info',

    add: 'customer/wish_list/add',
    remove: 'customer/wish_list/remove',
    wish_list: 'customer/wish_list',
    addAddress: 'customer/address/add',
    updateAddress: 'customer/address/update',
    getAddress: 'customer/address/list',
    // Cart
    cart: 'cart',
    addToCart: 'cart/add',
    updateCart: 'cart/update',
    removeCart: 'cart/remove',
    removeAllCart: 'cart/remove_all',
    contactUs: 'contact-us',
    applyCoupon: 'coupon/apply',
    CouponList: 'coupon/list',
    orderSummary: 'customer/order/summary',
    placeOrder: 'customer/order/place',
    statusupdate: 'customer/order/status-update',
    Orderlists: 'customer/order/list',
    orderDetailById: 'customer/order/details',
    profileupdate: 'customer/update-profile',

    trackOrder: 'order/order-tracking-update'


    // kuvah Api End





    // SentOtp: 'SentOtp/SentOtp',
    // VerifyOTP: 'SentOtp/VerifyOTP',
    // loginVerify: "LoginDetail/loginVerify",


    // loginOTP: "LoginDetail/loginOTP",

    // login: 'LoginDetail/login',
    // SaveLoginDetail: 'LoginDetail/SaveLoginDetail',
    // GetLoginDetailByUserPass: 'LoginDetail/GetLoginDetailByUserPass',
    // GetLoginDetailAll: 'LoginDetail/GetLoginDetailAll',
    // GetLoginDetailByMobileNo: 'LoginDetail/GetLoginDetailByMobileNo',
    // GetLoginDetailById: 'LoginDetail/GetLoginDetailById',
    // ForgotPassword: 'LoginDetail/ForgotPassword',
    // UpdatePasswordByLoginDetailById: 'LoginDetail/UpdatePasswordByLoginDetailById',
    // SaveUserImage: 'LoginDetail/SaveUserImage',

    // GetProductDetailAll: 'ProductDetail/GetProductDetailAll',
    // GetProductDetailById: 'ProductDetail/GetProductDetailById',
    // GetProductDetail: 'ProductDetail/GetProductDetail',
    // GetProductDetailAlls: 'ProductDetail/GetProductDetailAlls',
    // GetProductDetailByisLoggedIn: 'ProductDetail/GetProductDetailByisLoggedIn',
    // GetProductDetailBySubCategoryIdWithisLoggedIn: 'ProductDetail/GetProductDetailBySubCategoryIdWithisLoggedIn',
    // SaveCancelStatus: 'ProductOrder/SaveCancelStatus',
    // GetCancelType: 'CancelType/GetCancelType',

    // GetProductOffer: 'ProductOffer/GetProductOffer',

    // GetProductCategory: 'ProductCategory/GetProductCategory',

    // GetProductSubCategory: 'ProductSubCategory/GetProductSubCategory',
    // GetProductSubCategoryByCategoryId: 'ProductSubCategory/GetProductSubCategoryByCategoryId',
    // GetProductDetailBySubCategoryId: 'ProductDetail/GetProductDetailBySubCategoryId',

    // SaveCartDetail: 'CartDetail/SaveCartDetail',
    // GetCartDetailAll: 'CartDetail/GetCartDetailAll',
    // // GetCartDetailByisLoggedIn: 'CartDetail/GetCartDetailByisLoggedIn',
    // DeleteCartDetailById: 'CartDetail/DeleteCartDetailById',
    // DeleteCartDetailByisLoggedIn: 'CartDetail/DeleteCartDetailByisLoggedIn',
    // SaveBulkCart: 'CartDetail/SaveBulkCart',

    // SaveUserAddress: 'UserAddress/SaveUserAddress',
    // GetUserAddressByisLoggedIn: 'UserAddress/GetUserAddressByisLoggedIn',
    // GetUserAddressByLoginAddressId: 'UserAddress/GetUserAddressByLoginAddressId',

    // ProductCheckout: 'Checkout/ProductCheckout',
    // GetState: 'State/GetState',
    // GetDistrictByStateId: 'District/GetDistrictByStateId',

    // CreateOrder: 'Checkout/CreateOrder',
    // SaveProductOrder: 'ProductOrder/SaveProductOrder',
    // UpdatePaymentResponse: 'ProductOrder/UpdatePaymentResponse',
    // GetProductOrderByisLoggedIn: 'ProductOrder/GetProductOrderByisLoggedIn',
    // GetProductOrderByOrderId: 'ProductOrder/GetProductOrderByOrderId',

    // GetCouponByIdCouponcode: 'Coupon/GetCouponByIdCouponcode',
    // GetShipTracking: 'ShipmentOrder/GetShipTracking',
    // GetDiscountByCouponcode: 'Coupon/GetDiscountByCouponcode',

    // GetProjectPaymentGatewayByProjectId: 'ProjectPaymentGateway/GetProjectPaymentGatewayByProjectId',
    // GetProjectPaymentGatewayByProjectNo: 'ProjectPaymentGateway/GetProjectPaymentGatewayByProjectNo',

    // GetProductRatingByProductId: 'ProductRating/GetProductRatingByProductId',
    // SaveProductRating: 'ProductRating/SaveProductRating',
    // GetProductRating: 'ProductRating/GetProductRating',

    // GetBlogDetail: 'BlogDetail/GetBlogDetail',
    // SaveEnquiry: 'Enquiry/SaveEnquiry',

    // SaveWishProduct: 'WishProduct/SaveWishProduct',
    // GetWishProductByisLoggedIn: 'WishProduct/GetWishProductByisLoggedIn',
    // DeleteWishProductByLoginProductId: 'WishProduct/DeleteWishProductByLoginProductId',

    // GetWeightTypeAll: 'WeightType/GetWeightTypeAll',
    // SaveWeightType: 'WeightType/SaveWeightType',
    // GetWeightType: 'WeightType/GetWeightType',
    // DeleteWeightTypeById: 'WeightType/DeleteWeightTypeById',
    // ActiveWeightTypeById: 'WeightType/ActiveWeightTypeById',

    // SaveShapeType: 'ShapeType/SaveShapeType',
    // GetShapeType: 'ShapeType/GetShapeType',
    // DeleteShapeTypeById: 'ShapeType/DeleteShapeTypeById',
    // ActiveShapeTypeById: 'ShapeType/ActiveShapeTypeById',

    // SaveSizeType: 'SizeType/SaveSizeType',
    // GetSizeType: 'SizeType/GetSizeType',
    // GetSizeTypeAll: 'SizeType/GetSizeTypeAll',
    // ActiveSizeTypeById: 'SizeType/ActiveSizeTypeById',
    // DeleteSizeTypeById: 'SizeType/DeleteSizeTypeById',
}